import type { IGallery } from '@/entities/common/types/gallery';
import type { IBaseDoctor } from '@/entities/doctor/model/types';
import type { IMedcenterDetails } from '@/entities/medcenter/model/types';

export function medcenterAdapter(medcenter: IMedcenterDetails): IMedcenterDetails {
  return {
    ...medcenter,
    avatar: process.env.NEXT_PUBLIC_ENV === 'dev' ? `https://idoctor.kz/${medcenter.avatar}` : medcenter.avatar,
  };
}

export function doctorsInMedcenterAdapter(doctors: IBaseDoctor[]): IBaseDoctor[] {
  if (process.env.NEXT_PUBLIC_ENV === 'prod') return doctors;

  return doctors.map(doctor => ({
    ...doctor,
    avatar: `https://idoctor.kz/${doctor.avatar}`,
  }));
}

export function adapterMedcenterGallery(gallery: IGallery[]): IGallery[] {
  if (process.env.NEXT_PUBLIC_ENV === 'prod')
    return gallery.map(img => ({
      ...img,
      original: `/${img.original}`,
    }));

  return gallery.map(img => ({
    ...img,
    thumbnail: process.env.NEXT_PUBLIC_ENV === 'dev' ? `https://idoctor.kz/${img.thumbnail}` : img.thumbnail,
    original: process.env.NEXT_PUBLIC_ENV === 'dev' ? `https://idoctor.kz/${img.original}` : img.original,
  }));
}
